<template>
  <v-container fluid class="pa-4">
    <v-card class="rounded-lg">
      <v-card-title class="d-flex justify-space-between align-center pa-4">
        <div class="d-flex align-center">
          <v-icon color="primary" class="mr-2">mdi-office-building</v-icon>
          <h2 class="font-weight-bold">기관 정보</h2>
        </div>
        <v-spacer></v-spacer>
        <AdminCompBasicEdit @success="readSsId()" />
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-row>
          <!-- 왼쪽 섹션: 기관 대표 이미지 -->
          <v-col cols="12" md="4">
            <v-card class="hover-card-motion mb-4 text-center pb-3" elevation="2">
            <v-card-title class="text-center">기관 대표사진</v-card-title>
            <v-img @click="dialog = true" :src="imageUrl" height="auto" max-height="400" contain class="cursor-pointer">
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-card>

            <v-card class="hover-card-motion" elevation="2">
              <v-card-title class="text-center">계약서 인감</v-card-title>
              <v-card-text class="text-center">
                <AdminCompSignImg />
              </v-card-text>
            </v-card>
          </v-col>

          <!-- 오른쪽 섹션: 기관 상세 정보 -->
          <v-col cols="12" md="8">
            <v-card class="hover-card-motion mb-4" elevation="2">
              <v-card-title class="d-flex align-center">
                <v-icon color="primary" class="mr-2">mdi-information-outline</v-icon>
                기본 정보
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-list>
                      <v-list-item>
                        <template v-slot:prepend>
                          <v-icon color="primary">mdi-office-building-outline</v-icon>
                        </template>
                        <v-list-item-title class="font-weight-bold">기관명</v-list-item-title>
                        <v-list-item-subtitle>{{ SsInfo.sisul_name }}</v-list-item-subtitle>
                      </v-list-item>

                      <v-list-item>
                        <template v-slot:prepend>
                          <v-icon color="primary">mdi-identifier</v-icon>
                        </template>
                        <v-list-item-title class="font-weight-bold">장기요양기관기호</v-list-item-title>
                        <v-list-item-subtitle>{{ SsInfo.sisul_code }}</v-list-item-subtitle>
                      </v-list-item>

                      <v-list-item>
                        <template v-slot:prepend>
                          <v-icon color="primary">mdi-card-account-details-outline</v-icon>
                        </template>
                        <v-list-item-title class="font-weight-bold">사업자등록번호</v-list-item-title>
                        <v-list-item-subtitle>{{ SsInfo.sisul_biz_num }}</v-list-item-subtitle>
                      </v-list-item>
                    </v-list>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-list>
                      <v-list-item>
                        <template v-slot:prepend>
                          <v-icon color="primary">mdi-map-marker-outline</v-icon>
                        </template>
                        <v-list-item-title class="font-weight-bold">기관 주소</v-list-item-title>
                        <v-list-item-subtitle>{{ SsInfo.sisul_addr }}</v-list-item-subtitle>
                      </v-list-item>

                      <v-list-item>
                        <template v-slot:prepend>
                          <v-icon color="primary">mdi-phone-outline</v-icon>
                        </template>
                        <v-list-item-title class="font-weight-bold">기관 전화번호</v-list-item-title>
                        <v-list-item-subtitle>{{ SsInfo.sisul_tell }}</v-list-item-subtitle>
                      </v-list-item>
                    </v-list>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <v-card class="hover-card-motion mb-4" elevation="2">
              <v-card-title class="d-flex align-center">
                <v-icon color="primary" class="mr-2">mdi-account-tie-outline</v-icon>
                대표자 정보
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-list>
                      <v-list-item>
                        <template v-slot:prepend>
                          <v-icon color="primary">mdi-account-outline</v-icon>
                        </template>
                        <v-list-item-title class="font-weight-bold">대표자 성명</v-list-item-title>
                        <v-list-item-subtitle>{{ SsInfo.sisul_boss_name }}</v-list-item-subtitle>
                      </v-list-item>

                      <v-list-item>
                        <template v-slot:prepend>
                          <v-icon color="primary">mdi-cellphone</v-icon>
                        </template>
                        <v-list-item-title class="font-weight-bold">대표자 번호</v-list-item-title>
                        <v-list-item-subtitle>{{ SsInfo.sisul_boss_phone }}</v-list-item-subtitle>
                      </v-list-item>

                      <v-list-item>
                        <template v-slot:prepend>
                          <v-icon color="primary">mdi-email-outline</v-icon>
                        </template>
                        <v-list-item-title class="font-weight-bold">대표자 이메일</v-list-item-title>
                        <v-list-item-subtitle>{{ SsInfo.sisul_boss_email }}</v-list-item-subtitle>
                      </v-list-item>
                    </v-list>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-list>
                      <v-list-item>
                        <template v-slot:prepend>
                          <v-icon color="primary">mdi-bank-outline</v-icon>
                        </template>
                        <v-list-item-title class="font-weight-bold">은행 정보</v-list-item-title>
                        <v-list-item-subtitle>{{ SsInfo.sisul_bank }} / {{ SsInfo.sisul_bank_num
                          }}</v-list-item-subtitle>
                      </v-list-item>

                      <v-list-item>
                        <template v-slot:prepend>
                          <v-icon color="primary">mdi-account-check-outline</v-icon>
                        </template>
                        <v-list-item-title class="font-weight-bold">예금주</v-list-item-title>
                        <v-list-item-subtitle>{{ SsInfo.sisul_bank_owner }}</v-list-item-subtitle>
                      </v-list-item>
                    </v-list>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <v-card class="hover-card-motion" elevation="2">
              <v-card-title class="d-flex align-center">
                <v-icon color="primary" class="mr-2">mdi-cog-outline</v-icon>
                서비스 정보
              </v-card-title>
              <v-card-text>
                <div class="d-flex flex-wrap gap-2 mb-4">
                  <v-chip v-for="(service, index) in sortedServices" :key="index" :color="service.color" size="large"
                    class="ma-1">
                    <v-icon start :color="service.color">mdi-check-circle</v-icon>
                    {{ service.type }}
                  </v-chip>
                </div>

                <!-- 서비스 관리 섹션 -->
                <v-divider class="mb-4"></v-divider>
                <h4 class="mb-3">서비스 관리</h4>
                
                <v-row>
                  <!-- 급여 서비스 -->
                  <v-col cols="12" md="6">
                    <v-card variant="outlined" class="pa-3">
                      <div class="d-flex align-center mb-3">
                        <v-checkbox
                          v-model="wageServiceEnabled"
                          color="blue-darken-2"
                          hide-details
                          class="me-2"
                        ></v-checkbox>
                        <v-icon color="blue-darken-2" class="me-2">mdi-cash-multiple</v-icon>
                        <span class="font-weight-bold">급여 서비스</span>
                      </div>
                      
                      <v-row v-if="wageServiceEnabled">
                        <v-col cols="12" sm="6">
                          <v-text-field
                            v-model="SsInfo.sisul_wage_in"
                            label="서비스 시작일"
                            type="date"
                            variant="outlined"
                            density="compact"
                            hide-details
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-text-field
                            v-model="SsInfo.sisul_wage_out"
                            label="서비스 종료일"
                            type="date"
                            variant="outlined"
                            density="compact"
                            hide-details
                            clearable
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>

                  <!-- 재무 서비스 -->
                  <v-col cols="12" md="6">
                    <v-card variant="outlined" class="pa-3">
                      <div class="d-flex align-center mb-3">
                        <v-checkbox
                          v-model="fnaServiceEnabled"
                          color="purple-darken-2"
                          hide-details
                          class="me-2"
                        ></v-checkbox>
                        <v-icon color="purple-darken-2" class="me-2">mdi-calculator</v-icon>
                        <span class="font-weight-bold">재무 서비스</span>
                      </div>
                      
                      <v-row v-if="fnaServiceEnabled">
                        <v-col cols="12" sm="6">
                          <v-text-field
                            v-model="SsInfo.sisul_fna_in"
                            label="서비스 시작일"
                            type="date"
                            variant="outlined"
                            density="compact"
                            hide-details
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-text-field
                            v-model="SsInfo.sisul_fna_out"
                            label="서비스 종료일"
                            type="date"
                            variant="outlined"
                            density="compact"
                            hide-details
                            clearable
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>

                <!-- 저장 버튼 -->
                <v-row class="mt-4">
                  <v-col cols="12" class="text-center">
                    <v-btn
                      color="primary"
                      size="large"
                      @click="updateServiceInfo"
                      :loading="loading"
                      prepend-icon="mdi-content-save"
                    >
                      서비스 정보 저장
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
    </v-card-text>
    </v-card>

    <!-- 이미지 업로드 다이얼로그 -->
    <v-dialog v-model="dialog" max-width="700" class="fontNotoSans400">
      <v-card>
        <v-card-title class="bg-primary text-white">
          <v-icon start color="white" class="mr-2">mdi-image-edit</v-icon>
          기관 대표사진 변경
        </v-card-title>
        <v-card-text class="pa-4">
          <v-alert type="warning" variant="tonal" class="mb-4">
            이미지 변경 시 기존 이미지는 삭제됩니다.
          </v-alert>

          <v-file-input accept="image/*" label="이미지 파일 선택" prepend-icon="mdi-camera" @change="handleFileUpload"
            class="mb-4"></v-file-input>

          <v-img :src="imageMiribogi || imageUrl" max-height="400" contain class="rounded-lg"></v-img>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="primary" variant="flat" @click="sendSisulMainImg" :loading="loading" class="mr-2">
            업로드
          </v-btn>
          <v-btn color="grey-darken-1" variant="outlined" @click="dialog = false">
            닫기
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script setup lang="ts">
import { useStore } from 'vuex';
const store = useStore();
import axios from "axios";
import { ref, onMounted, computed, onUnmounted } from "vue";
import { } from "@mdi/js";
import AdminCompSignImg from "../../../components/admin/basic-info/AdminCompSignImg.vue";
import AdminCompBasicEdit from "../../../components/admin/basic-info/AdminCompBasicEdit.vue";
import '@/assets/styles/comp-basic-info.scss';

interface SisulInfo {
  sisul_code: string;
  sisul_name: string;
  sisul_biz_num: string;
  sisul_wage_in: string;
  sisul_wage_out: string | null;
  sisul_fna_in: string;
  sisul_fna_out: string | null;
  sisul_meal_in: string;
  sisul_meal_out: string | null;
  [key: string]: string | null;
}

const id = ref<string>("");
const SsInfo = ref<SisulInfo>({
  sisul_code: "",
  sisul_name: "",
  sisul_biz_num: "",
  sisul_wage_in: "",
  sisul_wage_out: null,
  sisul_fna_in: "",
  sisul_fna_out: null,
  sisul_meal_in: "",
  sisul_meal_out: null
});
type Service = {
  type: string;
  in: string;
  out: string | null;
  color: string;
};
const services = ref<Service[]>([]);

const sortedServices = computed(() => {
  return services.value
    .filter((service) => service.in && !service.out)
    .sort((a, b) => new Date(a.in).getTime() - new Date(b.in).getTime());
});

const dialog = ref(false);
const loading = ref(false);
const imageMiribogi = ref();
const imageFile = ref();
const ext = ref();
const imageType = ref();
const imageUrl = ref();
const imgName = ref();

// 서비스 체크박스 관련 변수들
const wageServiceEnabled = ref(false);
const fnaServiceEnabled = ref(false);

// 서비스 정보 업데이트 함수
const updateServiceInfo = async () => {
  loading.value = true;
  try {
    const form = {
      sisul_id: SsInfo.value.sisul_code,
      sisul_wage_in: wageServiceEnabled.value ? SsInfo.value.sisul_wage_in : null,
      sisul_wage_out: wageServiceEnabled.value ? SsInfo.value.sisul_wage_out : null,
      sisul_fna_in: fnaServiceEnabled.value ? SsInfo.value.sisul_fna_in : null,
      sisul_fna_out: fnaServiceEnabled.value ? SsInfo.value.sisul_fna_out : null,
    };

    const response = await axios.put(`/api/updateSsInfo`, { form });
    
    if (response.data.success) {
      store.commit('showSnackbar', {
        text: "서비스 정보가 성공적으로 업데이트되었습니다.",
        color: "success"
      });
      
      // 서비스 정보 다시 로드
      await readSsId();
    } else {
      store.commit('showSnackbar', {
        text: "서비스 정보 업데이트에 실패했습니다.",
        color: "error"
      });
    }
  } catch (error) {
    console.error('서비스 정보 업데이트 중 오류:', error);
    store.commit('showSnackbar', {
      text: "서비스 정보 업데이트 중 오류가 발생했습니다.",
      color: "error"
    });
  } finally {
    loading.value = false;
  }
};
const handleFileUpload = (event: Event) => {
  const target = event.target as HTMLInputElement;
  if (target.files && target.files.length > 0) {
    const file = target.files[0];
    ext.value = file.name.split(".").pop();
    const reader = new FileReader();
    reader.onload = () => {
      imageMiribogi.value = reader.result;
    };
    reader.readAsDataURL(file);
    imageFile.value = file;
  }
};
const fetchImage = async () => {
  imageUrl.value = await getSisulMainImg();
};
const getSisulMainImg = async () => {
  loading.value = true;
  try {
    const response = await axios.get(`/api/getSisulMainImg/${imgName.value}`, {
      responseType: "blob",
    });
    if (response.data) {
      //이미지타입 추출
      imageType.value = response.data.type.split("/")[1];
      if (imageType.value === "jpeg") {
        imageType.value = "jpg";
      }
      const imageBlob = response.data;
      const imageObjectURL = URL.createObjectURL(imageBlob);
      return imageObjectURL; // 가져온 이미지 URL을 반환
    }
  } catch (error) {
    const imageObjectURL = "nothing";
    return imageObjectURL;
  } finally {
    loading.value = false;
  }
};

const sendSisulMainImg = async () => {
  if (!imageFile.value) {
    alert("이미지를 선택하세요.");
    return;
  }
  const allowedTypes = ["image/jpeg", "image/png"];
  if (!allowedTypes.includes(imageFile.value.type)) {
    alert("JPG 또는 PNG 파일만 업로드 가능합니다.");
    loading.value = false;
    return;
  }
  loading.value = true;

  try {
    if (imageUrl.value !== "nothing") {
      await deleteSilsulMainImg();
    }
    const formData = new FormData();
    formData.append("image", imageFile.value);
    const response = await axios.post(
      `/api/sendSisulMainImg/${imgName.value}/${ext.value}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    if (response && response.data.success) {
      await fetchImage();
      dialog.value = false;
    } else {
      console.error("이미지 업로드 실패", response.data);
    }
  } catch (error) {
    console.error("이미지 업로드 중 에러 발생", error);
  } finally {
    loading.value = false;
  }
};
const deleteSilsulMainImg = async () => {
  try {
    const response = await axios.post(`/api/deleteSilsulMainImg/${imgName.value}`);
    if (!response) {
      alert("기존 파일 삭제 에러 발생.");
      return;
    }
  } catch (error) {
    console.error("이미지 업로드 중 에러 발생", error);
  }
};

const readSsId = async () => {
  try {
    const response = await axios.get(`/api/readSsId/${id.value}`);
    const responseData = response.data;
    if (responseData) {
      SsInfo.value = responseData;
      services.value = [
        {
          type: "노무관리",
          in: SsInfo.value.sisul_wage_in,
          out: SsInfo.value.sisul_wage_out,
          color: "blue-darken-2",
        },
        {
          type: "재무회계",
          in: SsInfo.value.sisul_fna_in,
          out: SsInfo.value.sisul_fna_out,
          color: "purple-darken-2",
        },
        {
          type: "위탁급식",
          in: SsInfo.value.sisul_meal_in,
          out: SsInfo.value.sisul_meal_out,
          color: "orange-darken-2",
        },
      ];
      imgName.value = SsInfo.value.sisul_code + "img";

      // 서비스 체크박스 상태 초기화
      wageServiceEnabled.value = !!(SsInfo.value.sisul_wage_in && !SsInfo.value.sisul_wage_out);
      fnaServiceEnabled.value = !!(SsInfo.value.sisul_fna_in && !SsInfo.value.sisul_fna_out);

      store.commit("setSsInfoBox", SsInfo.value);
      return responseData;
    } else {
      console.error("에러가 발생했습니다.");
    }
  } catch (error) {
    console.error("errorMsg:", error);
  }
};
onMounted(async () => {
  id.value = store.state.AdminSisulId;
  await readSsId();
  await fetchImage();
});
onUnmounted(() => {
  sessionStorage.removeItem("SsInfoBox");
});
</script>
